import  axiosInstance  from "../utils/api";
 
import endpoints from "../constants/endpoints";

 export const ClientSideEndpoints = {

    getDetailsForHomePage: async () => {
        try {
            const response = await axiosInstance.get(`${endpoints.fetchInfoForHomePage}`);
            return response.data;
        } catch (error) {
            throw new Error('Failed to fetch products: ' + error.message);
        }
    },
    getEnhancedDetailsForHomePage: async () => {
    try {
        const response = await axiosInstance.get(`${endpoints.fetchEnhancedHomePageData}`);
        return response.data;
    } catch (error) {
        throw new Error('Failed to fetch enhanced homepage data: ' + error.message);
    }
},

getMostCustomizedSection: async () => {
    try {
        const response = await axiosInstance.get(`${endpoints.fetchMostCustomizedSection}`);
        return response.data;
    } catch (error) {
        throw new Error('Failed to fetch most customized section: ' + error.message);
    }
},
    getProductsBasedOnCategory: async (categoryId) => {
        try {
            const response = await axiosInstance.get(`${endpoints.fetchListOfProductsBaseOnCategory(categoryId)}`);
            return response.data;
        } catch (error) {
            throw new Error('Failed to fetch products: ' + error.message);
        }
    },
    getProductsBasedOnSubCategory: async (subCategoryId) => {
        try {
            const response = await axiosInstance.get(`${endpoints.fetchListOfProductsBaseOnSubCategory(subCategoryId)}`);
            return response.data;
        } catch (error) {
            throw new Error('Failed to fetch products: ' + error.message);
        }
    },

    addToProductOrProjectToFavorites: async (formData) => {
        try {
            const response = await axiosInstance.post(`${endpoints.addToProductOrProjectToFavorites}`,  formData, );
            return response.data;
        } catch (error) {
            throw new Error('Failed to add to favorites: ' + error.message);
        }
    },
    removeProductOrProjectFromFavorites: async (itemId) => {
        try {
            const response = await axiosInstance.post(`${endpoints.removeProductOrProjectFromFavorites(itemId)}`);
            return response.data;
        } catch (error) {
            throw new Error('Failed to remove from favorites: ' + error.message);
        }
    },
    addProductToCart: async (formData) => {
        try {
            const response = await axiosInstance.post(`${endpoints.addProductToCart}`, formData);
            return response.data;
        } catch (error) {
            throw new Error('Failed to add to cart: ' + error.message);
        }
    },
    removeProductFromCart: async (itemId) => {
        try {
            const response = await axiosInstance.post(`${endpoints.removeProductFromCart(itemId)}`);
            return response.data;
        } catch (error) {
            throw new Error('Failed to remove from cart: ' + error.message);
        }
    },
    fetchListOfProductsInCart: async () => {
        try {
            const response = await axiosInstance.get(`${endpoints.fetchListOfProductsInCart}`);
            return response.data;
        } catch (error) {
            throw new Error('Failed to fetch products in cart: ' + error.message);
        }
    },
    searchAndFilterProductItems: async (formData) => {
        try {
            const response = await axiosInstance.post(`${endpoints.searchAndFilterProductItems}`, formData);
            return response.data;
        } catch (error) {
            throw new Error('Failed to search and filter products: ' + error.message);
        }
    },
    fetchListOfFavorites: async () => {
        try {
            const response = await axiosInstance.get(`${endpoints.fetchListOfProductsOrProjectsInFavorites}`);
            return response.data;
        } catch (error) {
            throw new Error('Failed to fetch favorites: ' + error.message);
        }
    }
    ,
  
 };
 